import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { buildPath } from '@e-socna/utils';

import {
  RIGHT_DRAWER_MAX_WIDTH,
  RightDrawer,
} from '../../../components/RightDrawer';
import { WordBreak } from '../../../components/WordBreak';

import type { SubMissionPricingCardItem } from './SubMissionPricingCards';

// The drawer fits its content: the service usage cards need its full width.
const FULL_WIDTH_SX = {
  '& .MuiDrawer-paper': {
    width: `min(${RIGHT_DRAWER_MAX_WIDTH.toFixed()}px, 100vw)`,
  },
};

interface Props {
  readonly items: readonly SubMissionPricingCardItem[];
  // The route pattern of the pricing page the drawer closes back to.
  readonly pagePath: string;
}

export const SubMissionPricingDrawer = ({
  items,
  pagePath,
}: Readonly<Props>) => {
  const params = useParams();
  const { subMissionId } = params;
  const navigate = useNavigate();

  const item = items.find(({ subMission }) => subMission._id === subMissionId);

  const handleClose = useCallback(() => {
    void navigate(buildPath(pagePath, params));
  }, [navigate, pagePath, params]);

  return (
    <RightDrawer
      isOpen={!!item}
      onDrawerClose={handleClose}
      subtitle={
        !!item && (
          <Typography color="text.secondary" component="p" variant="subtitle1">
            <WordBreak>{item.subMission.code}</WordBreak>
          </Typography>
        )
      }
      sx={FULL_WIDTH_SX}
      title={item?.subMission.title}
    >
      {!!item && <Box sx={{ width: '100%' }}>{item.detail}</Box>}
    </RightDrawer>
  );
};
